import { useMemo } from "react";
import { IoCheckmark, IoCheckmarkDone } from "react-icons/io5";

type ReadStatus = "admin-notReaded" | "client-readed" | "client-notReaded";
type Props = {
  unreadCountSupport: number;
  unreadCountUser: number;
  isActiveChat?: boolean;
};

export const ChatSummaryReadingIcon = ({ unreadCountSupport, unreadCountUser, isActiveChat }: Props) => {
  const readStatus = useMemo((): ReadStatus => {
    if (unreadCountSupport > 0 && !isActiveChat) return "admin-notReaded";
    if (unreadCountUser > 0) return "client-notReaded";
    return "client-readed";
  }, [unreadCountUser, unreadCountSupport, isActiveChat]);

  switch (readStatus) {
    case "admin-notReaded":
      return (
        <span className="  size-[30px] text-xs  flex_center rounded-full bg-red-400 text-white ">
          {unreadCountSupport > 10 ? "10+" : unreadCountSupport}
        </span>
      );

    case "client-notReaded":
      return <IoCheckmark className="   text-green-500" />;
    case "client-readed":
      return <IoCheckmarkDone className="   text-green-500" />;
  }
};
